import Component from "../../Component";
import BaseApi from "./BaseApi";
import { FloorPlan } from "../types";

/**
 * Floorplan API - Handles all floorplan-related operations
 * Extends BaseApi for consistent error handling and authentication
 * Follows Single Responsibility Principle
 */
export default class FloorplanApi extends BaseApi {
    constructor(component: Component) {
        super(component);
    }

    /**
     * Fetches all available floorplans
     * @returns Promise<Floorplan[]> Array of all floorplans
     */
    public async fetchAll(): Promise<FloorPlan[]> {
        return this.fetchWithAuth<FloorPlan[]>("/floorplan");
    }

    public async fetchSVGById(floorId: string): Promise<any> {
        return this.fetchWithAuthRAW<any>(`/floorplan/svg/${floorId}`);
    }
}
